/**
 * annotationConstants.ts — Constants for the teacher annotation/coloration system.
 *
 * Used by ColorationToolbar, useTextColoration, and ProfileView for
 * character-level annotations (colors, font sizes, underlines).
 */

// {{{ auto-color vowel defaults (must match compact-picker palette swatches)
/** Foreground color for consonants bearing kamatz katan (compact-picker deep orange) */
export const DEFAULT_KAMATZ_KATAN_COLOR = '#E27300'

/** Foreground color for consonants bearing shewa na (compact-picker bright green) */
export const DEFAULT_SHEWA_NA_COLOR = '#68BC00'
// }}}

// {{{ annotation format presets — semantic values stored in DB
/** Semantic font-size annotation value for "Large" preset */
export const FONT_SIZE_LARGE = 'large'

/** Semantic font-size annotation value for "X-Large" preset */
export const FONT_SIZE_XLARGE = 'xlarge'
// }}}

// {{{ CSS rendering — used only by characterStyleToCss()
/** Maps semantic font-size annotation values to CSS font-size values */
export const FONT_SIZE_CSS_MAP: Record<string, string> = {
  [FONT_SIZE_LARGE]: '130%',
  [FONT_SIZE_XLARGE]: '160%',
}

/** CSS border-bottom value for underline annotation (sits below nikkud, unlike text-decoration) */
export const ANNOTATION_UNDERLINE = '2px solid currentColor'
// }}}

// {{{ coloration interaction timing
/** Guard window (ms) to prevent unwanted mousedown after dblclick selection in coloration mode. */
export const COLORATION_INTERACTION_GUARD_MS = 300
// }}}
